import React, { useMemo, useState } from 'react';
import { Else, If, Then } from 'react-if';

import { colors } from '@nerdwallet/base-styles/variables';
import { Box } from '@nerdwallet/currency/components/Box';
import { Button } from '@nerdwallet/currency/components/Button';
import { Text } from '@nerdwallet/currency/components/Text';

import AppDownloadPopover from '@components/app-download-popover';
import TwoSparklesIcon from '@components/icons/two-sparkles-icon';
import useIsMobile from '@lib/hooks/use-is-mobile';
import { useAnalytics } from '@lib/segment';
import { getMobileOperatingSystem } from '@lib/utils';

import styles from './index.module.css';
import qrCode from './qr-code.svg';

const AppDownloadFooter: React.FC = () => {
  const { segmentTrack } = useAnalytics();

  //  Determining if it is mobile device
  const { isDesktop } = useIsMobile();
  const isMobile = useMemo(
    () => !isDesktop && !!getMobileOperatingSystem(),
    [isDesktop],
  );

  const [qrCodeAnchorEl, setQRCodeAnchorEl] = useState<HTMLElement | null>(
    null,
  );

  const trackClick = () => segmentTrack('Credit Score Deprecation CTA Clicked');

  return (
    <Box
      alignItems="center"
      backgroundColor="yellow-lightest"
      className={styles.container}
      display="flex"
      justifyContent="space-between"
      paddingX="4"
      paddingY="3"
      width="100"
    >
      <If condition={isMobile}>
        <Then>
          <Text bold size="small">
            View in the NerdWallet app
          </Text>
          <Button
            onClick={() => {
              trackClick();
              window.open(
                'https://click.nerdwallet.com/3687710914/fzk59h6l',
                '_blank',
              );
            }}
            primary
          >
            Open
          </Button>
        </Then>
        <Else>
          <Box alignItems="center" display="flex" gridGap="3">
            <TwoSparklesIcon fillColor={colors['green']} />
            <Text bold>View the full feature in the NerdWallet app</Text>
          </Box>
          <Button
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              trackClick();
              setQRCodeAnchorEl(e?.currentTarget);
            }}
            primary
          >
            Get the app
          </Button>
          <AppDownloadPopover
            anchorEl={qrCodeAnchorEl}
            onClose={() => setQRCodeAnchorEl(null)}
            open={!!qrCodeAnchorEl}
            qrCode={qrCode}
          />
        </Else>
      </If>
    </Box>
  );
};

export default AppDownloadFooter;
